import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ISignatureRequest } from '@clickersphere/core/entities/ISignatureRequest';
import LeadContractService, {
  ICreateSignatureRequestParams,
} from '@clickersphere/core/services/LeadContractService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { SIGNATURE_REQUESTS_QUERY_KEY } from './useSignatureRequests';

interface ICreateSignatureRequestVariables {
  leadId: string;
  contractId: string;
  data: ICreateSignatureRequestParams;
}

export function useCreateSignatureRequest() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    isPending: createSignatureRequestIsPending,
    mutateAsync: createSignatureRequestAsync,
  } = useMutation<ISignatureRequest, unknown, ICreateSignatureRequestVariables>(
    {
      mutationFn: ({ leadId, contractId, data }) =>
        LeadContractService.createSignatureRequest(leadId, contractId, data),
      onSuccess: async (_result, variables) => {
        await queryClient.invalidateQueries({
          queryKey: buildQueryKey([
            SIGNATURE_REQUESTS_QUERY_KEY,
            variables.leadId,
            variables.contractId,
          ]),
        });
      },
    },
  );

  return {
    createSignatureRequestAsync,
    createSignatureRequestIsPending,
  };
}
